import List from '../../../../components/Operations/TaskSystem/Lines/List'
import TaskSystemLinesModal from '../../../../components/Operations/TaskSystem/Lines/TaskSystemLinesModal'
import React, { Fragment } from 'react'

function TaskSystemLines(props) {
  return (
    <Fragment>
      <TaskSystemLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default TaskSystemLines
